import React, { useState, useEffect } from 'react'

import { Col, Row, Table, Popconfirm, message, Button } from 'antd'

import doUtility from '../utility'

import { MiniLoader, Loader, downloadFile } from '../utility/componentUtility'

import ReportStore from '../../store/slice/report.slice'

import { DownloadOutlined } from '@ant-design/icons'

function BranchReports(props) {

    const brCode = props.branchCode

    const BrReport_list = ReportStore((state) => state.BrReport_list)
    const getReportList = ReportStore((state) => state.getReportList)

    const BrReport_down = ReportStore((state) => state.BrReport_down)
    const getReportDown = ReportStore((state) => state.getReportDown)

    const [SelectRecord, changeSelectedRecord] = useState([])

    const [loading, setLoading] = useState(false)
    
    const confirm = async (e) => {
        setLoading(true)
        await getReportDown(brCode, SelectRecord.REP_SEQ).then((r)=>{
            if(r.data.Format == 'EXCEL'){
                const FileName = brCode+'-'+SelectRecord.REPORT_NAME.replaceAll(' ', '_')+'.xls'
                downloadFile('xls', r.data.data_base64, FileName)
                //downloadXLSX(r.data.data_base64, FileName)
            }
            setLoading(false)
            message.info('Downloading Completed...', 2.5)
        })
    }


    const action = {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <Popconfirm title="Please Confirm To Download ?" onConfirm={confirm}>
                <Button type="default" icon={<DownloadOutlined />} onClick={ () => { changeSelectedRecord(record) } }>
                </Button>
            </Popconfirm>
        )
    }

    useEffect(() => {
        getReportList(brCode)
    }, [brCode])


    return(
        <Row>

            {loading ? <Loader /> : ''}

            <a href="#" id="dwnlink"></a>
            
            <Col md={24}>
               {( () => {
                    if (BrReport_list && BrReport_list.length > 0) {
                        if(BrReport_list === 'loading'){
                            return (
                                <MiniLoader />
                            )
                        }else{
                            const filterBrReport_list = doUtility.RenderTableData(BrReport_list)
        
                            filterBrReport_list.column.filter(item => item.dataIndex)
                                    
                            const column = filterBrReport_list.column.filter(function(item) {
                                if(item.dataIndex == 'REP_SEQ' ){
                                    return false
                                }else{
                                    return true
                                }
                            });
                                            
                            return (
                                <Table
                                    className='back-white p10' 
                                    style={{ margin: 'auto', borderRadius: '2px'}} 
                                    dataSource={filterBrReport_list.datasource} columns={[...column, action]} />
                            )
                        }
                    }
                }) ()}
            </Col>
        </Row>
    )
}


function AgentsReports(props) {
    return(
        <div> Agents Reports </div>    
    )
}

const downloadXLSX = (pdf, file_name="donwload.xlsx") => {
    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${pdf}`
    //const linkSource = `data:application/vnd.ms-excel;base64,${pdf}`
    //application/vnd.ms-excel
    const downloadLink = document.createElement("a")
    downloadLink.href = linkSource
    downloadLink.setAttribute('download', file_name);
    downloadLink.target = "_blank"
    downloadLink.click()
}

export { AgentsReports, BranchReports }